export const adStateEnum = {
  IDLE: 'idle',
  LOADED: 'loaded',
  STARTED: 'started',
  COMPLETED: 'completed',
  PAUSED: 'paused',
  STOPPED: 'stopped',
  ERROR: 'error'
};

export const viewModeEnum = {
  NORMAL: 'normal',
  FULLSCREEN: 'fullscreen',
  THUMBNAIL: 'thumbnail'
};

export type VPAIDViewMode = 'thumbnail' | 'fullscreen' | 'normal';

export type AdUnitVersion = 1 | 2;

export interface VPAIDAdUnitV1 {
  handshakeVersion(expectedVersion: string): string;

  initAd(
    width: number,
    height: number,
    viewMode: VPAIDViewMode,
    desiredBitrate: number,
    creativeData?: {
      AdParameters: string;
    },
    environmentVars?: {
      slot: HTMLElement | null;
      videoSlot: HTMLVideoElement | null;
      videoSlotCanAutoPlay: boolean;
    }
  ): void;

  startAd(): void;

  subscribe(func: Function, eventName: string): void;

  resizeAd(width: number, height: number, viewMode?: VPAIDViewMode): void;

  pauseAd(): void;

  stopAd(): void;

  resumeAd(): void;

  expandAd(): void;

  collapseAd(): void;

  setAdVolume(volume: number): void;

  getAdSkippableState(): boolean;

  adLinear: boolean;

  adExpanded: boolean;

  adRemainingTime: number;

  adVolume: number;
}

export interface VPAIDAdUnitV2 extends VPAIDAdUnitV1 {
  skipAd(): void;
  getAdVolume?(): number;

  adWidth: number;

  adHeight: number;

  adSkippableState: boolean;

  adDuration: number;

  adCompanions: string;

  adIcons: boolean;
}

export const dispatchedEventsByVersionMap: Record<string, number> = {
  AdLoaded: 1,
  AdStarted: 1,
  AdStopped: 1,
  AdLinearChange: 1,
  AdExpandedChange: 1,
  AdRemainingTimeChange: 1,
  AdVolumeChange: 1,
  AdImpression: 1,
  AdVideoStart: 1,
  AdVideoFirstQuartile: 1,
  AdVideoMidpoint: 1,
  AdVideoThirdQuartile: 1,
  AdVideoComplete: 1,
  AdClickThru: 1,
  AdUserAcceptInvitation: 1,
  AdUserMinimize: 1,
  AdUserClose: 1,
  AdPaused: 1,
  AdPlaying: 1,
  AdLog: 1,
  AdError: 1,

  AdSkipped: 2,
  AdSkippableStateChange: 2,
  AdSizeChange: 2,
  AdDurationChange: 2,
  AdInteraction: 2
};

export type AdUnitEventName = keyof typeof dispatchedEventsByVersionMap;

export const getDispatchedEvents: (
  version: AdUnitVersion
) => AdUnitEventName[] = function(version: AdUnitVersion): AdUnitEventName[] {
  return Object.keys(dispatchedEventsByVersionMap).filter(k => {
    return dispatchedEventsByVersionMap[k] <= version;
  }) as AdUnitEventName[];
};
